import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { AppLoader } from '~/components/loader'
import { LinkButtonHref } from '~/features/navigation'
import { useTitle } from '~/hooks'
import { useTRPC } from '~/services/trpc'
import { PublicTemplate } from '~/templates/public'

import { Icon } from '@hap/components'

export const Route = createFileRoute(
  '/_authenticated/$alias/integrations/$integrationId/activate',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useParams()
  const trpc = useTRPC()
  const { data } = useQuery(
    trpc.integrations.fromIntegrationId.queryOptions(params.integrationId),
  )

  useTitle('Activate Integration')

  if (!data) return <AppLoader />
  const integration = data[0]
  const config = integration.config as Record<string, unknown>
  if (!integration)
    return (
      <PublicTemplate width={400}>
        <div className="bg-accent text-center">
          <div className="flex flex-col content-center justify-center space-y-6 p-8 pb-16">
            <Icon
              name="warning-diamond"
              size="60"
              className="fill-earth-yellow mx-auto h-[100px]"
              weight="fill"
            />
            <p>
              Your organization is not set up to use this integration. Please contact
              support at help@happitu.com
            </p>
          </div>
        </div>
      </PublicTemplate>
    )

  return (
    <PublicTemplate>
      <div className="bg-accent space-y-10 px-8 py-10 text-center">
        <div className="flex justify-center gap-2">
          <div className="flex aspect-square h-[100px] shrink-0 items-center justify-center rounded-md bg-white p-4">
            <img src="https://www.mycase.com/favicon.png" className="w-fit" />
          </div>
        </div>

        <h1 className="text-center text-2xl font-semibold">MyCase Integration</h1>
        <p>
          Connect MyCase to automatically sync call records in your cases with transcripts
          and AI-generated call summaries.
        </p>
        <LinkButtonHref
          href={`https://auth.mycase.com/login_sessions/new?client_id=${config.clientId}&redirect_uri=${config.redirectUri}&response_type=code&state=${integration.organizationIntegrationId}`}
          size="lg"
        >
          Activate Integration
        </LinkButtonHref>
      </div>
    </PublicTemplate>
  )
}
